/* eslint-disable */
import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
// import parseWKT from 'wellknown'

import ShowOnVisible from 'Components/ShowOnVisible'
import { Collapsible } from 'Components'
import useWindowSize from 'Hooks/useWindowSize'
// import { getIsWithinPolygon } from 'Utils/schoolUtils'
import {_Title } from './styles'
import {
  SchoolRowLarge,
  SchoolRowSmall,
} from './components'

const NearbySchools = (
  {
    targetPoint, 
    source,
    schools,
    googleAnalyticsEvent,
    title,
    collapsibleIdSuffix,
    address,
    schoolBoundaryData,
    // isFetching,
  }
) => {
  if (!schools) return null
  if(source === 'school') return ''
  const googleEventsSchoolName = () => {
    googleAnalyticsEvent({
      category: `[${source ? source : 'listing'}]`,
      action: '[Nearby School][School name click]',
    })
  }
  const { winWidth } = useWindowSize()

  let inBoundarySchools = []
  let outBoundarySchools = []
  let noBoundarySchools = []
  const schoolsWithBoundaryInfo =schools?.forEach(school => {
    // const boundaryGeoJson = school.boundary ? school.boundary : null
    // const isInBoundary = targetPoint && boundaryGeoJson ?
    //   getIsWithinPolygon({
    //     point: targetPoint, boundary: boundaryGeoJson,
    //   }) : false
    // const schoolObj = { ...school, isInBoundary, boundary: boundaryGeoJson }
    // if(isInBoundary) {
    //   inBoundarySchools.push(schoolObj)
    // } else {
    //   outBoundarySchools.push(schoolObj)
    // }
    if(school?.catchment && schoolBoundaryData){
      const isInBoundary = schoolBoundaryData[school?.catchment] === 1
      const schoolObj = { ...school, isInBoundary }
      if(isInBoundary){
        inBoundarySchools.push(schoolObj)
      }else {
        outBoundarySchools.push(schoolObj)
      }
    } else {
      noBoundarySchools.push({...school, isInBoundary: false,hasNoBoundary: true})
    }
  })

  const sortedSchools = [ ...inBoundarySchools, ...outBoundarySchools, ...noBoundarySchools ]
  return (
    <Collapsible
      inputId={`Nearbyschools-${collapsibleIdSuffix}`}
      title={`Nearby Schools`}
      seoText={
        `Learn about the schools around ${title || ''}`
      }
      gaActionTitle="Nearby Schools"
      // openCollapseTargetId={openCollapseTargetId}
    >
      <ShowOnVisible offset={{ bottom: -300 }}>
        {/*<_Title>Nearby Schools</_Title>*/}
        {
          winWidth < 767
            ? <SchoolRowSmall schools={sortedSchools} targetPoint={targetPoint} googleEventsSchoolName={googleEventsSchoolName} />
            : <SchoolRowLarge schools={sortedSchools} targetPoint={targetPoint} googleEventsSchoolName={googleEventsSchoolName} />
        }
      </ShowOnVisible>
    </Collapsible>
  )
}
NearbySchools.propTypes = {
  schools: PropTypes.arrayOf(PropTypes.shape({})),
  targetPoint: PropTypes.shape({}),
}

export default NearbySchools

